import template from './customer.html';
import controller from './customer.controller';
import './customer.scss';

let customerComponent = {
  restrict: 'E',
  bindings: {
  	acl: '=',
    hasACL:'='
  },
  template,
  controller
};

export default customerComponent;


// WEBPACK FOOTER //
// ./client/app/components/tnt_billing/components/customer/customer.component.js